export const LabClassifications = {
  LAB: 'lab',
  PROJECT: 'project',
};

export const CLASSIFICATION_OPTIONS = Object.values(LabClassifications);
